import React from 'react';
import { useLanguage } from '../LanguageContext';
import { CONTENT } from '../content';

export default function OnboardingPromo() {
  const { language } = useLanguage();
  const t = CONTENT[language].home.onboardingPromo;

  return (
    <div className="mt-8 transform hover:scale-105 transition-all duration-300">
      <div className="bg-gradient-to-r from-suncoast-dark to-suncoast-primary rounded-xl p-1 shadow-lg">
        <div className="bg-white rounded-lg p-6 h-full flex items-center gap-5">
            <div className="bg-green-100 p-4 rounded-full flex-shrink-0">
               <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
               </svg>
            </div>
            <div>
               <div className="flex items-center gap-2 mb-1">
                 <span className="text-xs font-bold text-suncoast-accent uppercase tracking-wider">{t.badge}</span>
               </div>
               <h3 className="text-xl font-bold text-gray-800 leading-tight mb-2">{t.title}</h3>
               <p className="text-gray-600 text-sm leading-relaxed mb-1">{t.desc}</p>
               <p className="text-[10px] text-gray-400 italic">{t.note}</p>
            </div>
        </div>
      </div>
    </div>
  );
}